import { render, staticRenderFns } from "./PostponementsListComponent.vue?vue&type=template&id=5036f779&scoped=true&"
import script from "./PostponementsListComponent.vue?vue&type=script&lang=js&"
export * from "./PostponementsListComponent.vue?vue&type=script&lang=js&"
import style0 from "./PostponementsListComponent.vue?vue&type=style&index=0&id=5036f779&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5036f779",
  null
  
)

export default component.exports